/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PersonalAssetTypeEnum {
    Other = 'other',
    Property = 'property',
    SavingsAccount = 'savingsAccount',
    Mortgage = 'mortgage',
    Equipment = 'equipment',
    Business = 'business',
    Cash = 'cash',
    MutualFund = 'mutualFund',
    Art = 'art',
    PensionSavings = 'pensionSavings',
    Bond = 'bond',
    Crowdfunding = 'crowdfunding'
}

export function PersonalAssetTypeEnumFromJSON(json: any): PersonalAssetTypeEnum {
    return PersonalAssetTypeEnumFromJSONTyped(json, false);
}

export function PersonalAssetTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetTypeEnum {
    return json as PersonalAssetTypeEnum;
}

export function PersonalAssetTypeEnumToJSON(value?: PersonalAssetTypeEnum | null): any {
    return value as any;
}

